module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/3-499475278736a174128116c8da3b634b.jpg";